"use client";

import { Mail, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
export default function ContactInformation() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const mapRef = useRef<HTMLDivElement>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!mapRef.current) return;
      const rect = mapRef.current.getBoundingClientRect();
      const scrollProgress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const offset = scrollProgress * 20;
      setParallaxOffset(offset);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={sectionRef} className="bg-dark-background py-16 px-6 md:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 md:grid-cols-2 md:gap-16 lg:gap-24">
          {}
          <div className={`flex flex-col gap-8 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            {}
            <div className="group flex items-start gap-4">
              <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg border border-muted bg-muted-dark-background transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:border-accent group-hover:bg-accent/10">
                <Mail className="h-6 w-6 text-foreground-dark transition-colors duration-[var(--duration-medium)] group-hover:text-accent" aria-hidden="true" />
              </div>
              <div className="flex flex-col gap-1">
                
                <Link to="mailto:contacto@guillermobogao.com" className="text-lg font-semibold text-foreground-dark transition-colors duration-[var(--duration-medium)] hover:text-accent focus-ring">
                  contacto@guillermobogao.com
                </Link>
              </div>
            </div>

            {}
            

            {}
            <div className="flex flex-col gap-1 border-t border-muted/30 pt-8">
              
              
            </div>

            {}
            <div className="flex flex-col gap-1">
              
              
            </div>
          </div>

          {}
          
        </div>
      </div>
    </section>;
}